'use client';

import { useTranslations } from 'next-intl';

import { useFeatureGate } from '@/hooks/use-feature-gate';
import { cn } from '@/lib/ui/utils';

import { getProposalFeedGridClass } from './proposal-feed-grid';

/** Column labels for the desktop (lg+) table — hidden on mobile and tablet. */
export function ProposalFeedListHeader({
  eventVariant = false,
}: {
  eventVariant?: boolean;
} = {}): React.ReactNode {
  const t = useTranslations('launchpad.feed.table');
  const proposalVotingEnabled = useFeatureGate('proposal_voting') === true && !eventVariant;

  return (
    <div
      className={cn(
        'hidden lg:grid',
        getProposalFeedGridClass(proposalVotingEnabled),
        'items-end pt-4 pb-4 px-4 text-caption font-medium text-foreground-tertiary',
      )}
      data-testid="proposal-feed-list-header"
    >
      <span className="col-start-1 min-w-0 truncate">{t('headerProposal')}</span>
      <span className="min-w-0 truncate">{t('headerFundingStatus')}</span>
      <span className="min-w-0 truncate">{t('headerCategory')}</span>
      <span className="min-w-0 truncate">{t('headerBackers')}</span>
      <span className="min-w-0 truncate">{t('headerProposalScore')}</span>
      <span className="min-w-0 truncate">{t('headerProposedBy')}</span>
      {proposalVotingEnabled ? <span className="min-w-0 truncate">{t('headerVotes')}</span> : null}
    </div>
  );
}
